import React, { useState, useEffect } from "react";
import DialogContent from "@mui/material/DialogContent";
import {
    TextField,
    Switch,
    Tooltip,
    Grid,
    MenuItem,
    Stack
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import currentUserToken from "CurrentUserToken";
import { get } from "aws-amplify/api";
import { I18n } from "aws-amplify/utils";
import { Typography } from "@mui/material";

function EmailInfoStep(props) {
    const [delayError, setDelayError] = useState(false);
    const [isLocked, setIsLocked] = useState(false);
    const validEmail = new RegExp('^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]{1,}[.][a-zA-Z]{2,}$');

    const handleChange = (event) => {
        props.handleMainFormData(event.target.name, event.target.value);
    };

    return (
        <DialogContent>
        <FormControl fullWidth margin="normal" className="custom-form-control">
            <TextField
            label={I18n.get("Account Number")}
            value={props.mainFormData.account_number}
            fullWidth
            margin="normal"
            name="account_number"
            InputProps={{
                readOnly: true,
            }}
            required
            disabled
            className="custom-text-field"
            />
            <FormHelperText>{I18n.get("Mandatory field")}</FormHelperText>
        </FormControl>

        <FormControl fullWidth margin="normal" className="custom-form-control">
          <InputLabel>{I18n.get("Rule")}</InputLabel>
          <Select
            value={props.mainFormData.rule || ""}
            onChange={handleChange}
            name="rule"
            label={I18n.get("Rule")}
            required
            autoFocus
          >
            <MenuItem value="email" key="email" name="email">
                {I18n.get("Email")}
            </MenuItem>
            <MenuItem value="subject" key="subject" name="subject">
                {I18n.get("Subject")}
            </MenuItem>
          </Select>
        </FormControl>
           
        { props.mainFormData.rule === "email" && props.mainFormData.unrec_email ? (
            <FormControl fullWidth margin="normal" className="custom-form-control">
                <TextField
                label={I18n.get("Email Address")}
                value={props.mainFormData.email_address}
                fullWidth
                margin="normal"
                name="email_address"
                InputProps={{
                    readOnly: true,
                }}
                required
                disabled
                className="custom-text-field"
                />
                <FormHelperText>{I18n.get("Mandatory field")}</FormHelperText>
            </FormControl>
            ) : props.mainFormData.rule === "subject" ? (
                <FormControl fullWidth margin="normal" className="custom-form-control">
                <TextField
                    label={I18n.get("Word key")}
                    value={props.mainFormData.word_key}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    name="word_key"
                    required
                    className="custom-text-field"
                /> 
                <FormHelperText>{I18n.get("Mandatory field")}</FormHelperText>
                </FormControl>
            ) : props.mainFormData.rule === "email" ? (
                <FormControl fullWidth margin="normal" className="custom-form-control">
                <TextField
                    label={I18n.get("Email Address")}
                    value={props.mainFormData.email_address}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    name="email_address"
                    required
                    className="custom-text-field"
                /> 
                {validEmail.test(props.mainFormData.email_address) ? 
                "" : <FormHelperText>{I18n.get("Invalid email address")}</FormHelperText>

                }
                <FormHelperText>{I18n.get("Mandatory field")}</FormHelperText>
                </FormControl>
            ) : ""
        }
        
        <FormControl fullWidth margin="normal" className="custom-form-control">
            <TextField
                required
                fullWidth
                label={I18n.get("Email Delay")} // Traduzione
                type="number"
                inputProps={{
                    min: 0,
                    max: 24,
                    onKeyDown: (e) => {
                    if (e.key !== "ArrowUp" && e.key !== "ArrowDown") {
                        e.preventDefault();
                    }
                    },
                }}
                value={props.mainFormData.delay}
                name={"delay"}
                onChange={handleChange}
                error={delayError}
                helperText={delayError ? I18n.get("Email delay is required") : ""} // Traduzione
                sx={{ mb: 2 }}
            />
        </FormControl>

        <FormControl fullWidth margin="normal" className="custom-form-control">
            <Typography variant="body2">
               { I18n.get("Create live signal email")}
            </Typography>
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                <Tooltip title={isLocked ? "Unlock" : "Unlock"}>
                    <Typography variant="body2"> Off  </Typography>
                </Tooltip>
                <Switch
                    checked={isLocked}
                    onChange={() => {setIsLocked(!isLocked); props.handleMainFormData("flag", !isLocked)}}
                    color="primary"
                />
                <Tooltip title={isLocked ? "Lock" : "Lock"}>
                    <Typography variant="body2"> On </Typography>
                </Tooltip>
            </Stack>
        </FormControl>

        </DialogContent>
    );
}

export default EmailInfoStep;
